import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { YoutubeVideoInterface } from "../../store/mine_craft/youtubeVideosSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    preview_url: minecraftUrls.remoteUrl(value.thumbnail_url) || value.yt_thumbnail_url
  };
}

const youtubeVideosEntity = new schema.Entity(
  'youtube_videos',
  {},
  {
    processStrategy
  }
);

const youtubeVideoEntity = new schema.Entity(
  'youtube_video',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { youtube_video: YoutubeVideoInterface }>(response.data.youtube_video, youtubeVideoEntity);
  return normalized.entities;
}

export const fetchYoutubeVideos = createAsyncThunk(
  'youtubeVideos/fetchYoutubeVideos',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/youtube_videos`, { params })
    const normalized  = normalize<any, { youtube_videos: { [key: string]: YoutubeVideoInterface } }>(response.data.youtube_videos, [youtubeVideosEntity]);

    return {
      youtube_videos: normalized.entities?.youtube_videos || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchYoutubeVideo = createAsyncThunk(
  'youtubeVideos/fetchYoutubeVideo',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/youtube_videos/${id}`);
    return normalizeInstance(response);
  }
);

export const createYoutubeVideo = createAsyncThunk(
  'youtubeVideos/createYoutubeVideo',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/youtube_videos`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateYoutubeVideo = createAsyncThunk(
  'youtubeVideos/updateYoutubeVideo',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/youtube_videos/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyYoutubeVideo = createAsyncThunk(
  'youtubeVideos/destroyYoutubeVideo',
  async (id: number) => {
    await mineCraftApi.delete(`/onesky/youtube_videos/${id}`);
    return { id: id };
  }
);

export const reorderYoutubeVideos = createAsyncThunk(
  'youtubeVideos/reorderYoutubeVideos',
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await mineCraftApi.patch('/onesky/youtube_videos/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
